import Logo from "../components/Logo"
import Card from "../components/Card"
import { useParams } from "react-router-dom"
import { useState } from "react"

function EmailVerification() {
  const [message, setMessage] = useState('')
  const  { id } = useParams();

 


 const handleResend = async (id) => {
  const sendOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
}
  await fetch(`${process.env.REACT_APP_API_URL}/auth/confirmation-mail/${id}`, sendOptions)
  .then (response => response.json())
  .then (data => {
    setTimeout(() => {
      setMessage('')
    } , 10000)
    setMessage(data.msg)
  })
  .catch(err => console.log(err))
     }

     const handleVerificationEmail = (e) => {
       handleResend(id);
     }

  return (
      <div className="login-container">
          <Logo/>
           <p className="text-success my-3">{message} </p>
          <Card>
          <div className="banner welcome-banner"></div>
          <h4 className="card-head"> 
          Verify Email
          </h4>
          <p className="card-text">
            Your account has been succesfully registered, To complete the verification process kindly click on the link sent to your mail.
          </p>
           
           <p className="card-text"> Didn’t get a mail  or not verified, 
            <span className="resend-btn" onClick={handleVerificationEmail}> Click here</span>
          
            </p>
          </Card>
          
      </div>
  )
}

export default EmailVerification